import url from './url';



export default url(() => '/collections/priorities');
